import api from "@/components/customAxios/Axios";
import { useToast } from "@/components/toast";
import { useLoader } from "@/context/loaderContext";
import { useState } from "react";

import Modal from "react-modal";

import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import Tooltip from "../Tooltip";
Modal.setAppElement("#root");

const customStyles = {
	overlay: {
		backgroundColor: "rgba(0, 0, 0, 0)", // fully transparent; change to rgba(0,0,0,0.5) for dim without blur
	},
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		zIndex: 1000,
		borderRadius: "10px",

		width: "100%", // Adjust modal width for responsiveness
		maxWidth: "700px", // Max width for larger screens
		maxHeight: "90vh", // Limit height for smaller screens
	},
};

const ChangePasswordModal = () => {
	const [modalIsOpen, setIsOpen] = useState(false);
	const { setLoading } = useLoader();
	const toast = useToast();
	const [showPassword, setShowPassword] = useState(false);
	const [showNewPassword, setNewShowPassword] = useState(false);
	const [userPassword, setUserPassword] = useState({
		currentPassword: "",
		newPassword: "",
		confirmPassword: "",
	});

	const handleChangePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setUserPassword((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};
	function openModal() {
		setIsOpen(true);
	}

	function closeModal() {
		setIsOpen(false);
	}

	const changePassword = async (e: any) => {
		e.preventDefault();
		if (userPassword.newPassword !== userPassword.confirmPassword) {
			toast.error({
				type: "background",
				duration: 3000,
				status: "Error",
				title: "Password mismatch",
				description: "New password and confirm password do not match. Please try again.",
				open: true,
			});
			return;
		}

		try {
			setLoading(true);
			const response = await api.post("/update_user_password", {
				user_id: localStorage.getItem("user"),
				current_password: userPassword.currentPassword,
				new_password: userPassword.newPassword,
			});
			if (response.status === 200) {
				toast.success({
					type: "background",
					duration: 3000,
					status: "Success",
					title: "Password updated successfully",
					description: "Your password has been updated successfully.",
					open: true,
				});
				closeModal();
			}
		} catch (error: any) {
			setLoading(false);
			toast.error({
				type: "background",
				duration: 5000,
				status: "error",
				title: "Error Changing Password",
				description: error.response?.data?.error || error.response?.data?.message || "Failed to update password. Please try again.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};

	return (
		<div>
			<p className="font-medium text-gray-400 mb-2">Password</p>

			<button
				className="hover:scale-110 transition bg-[#BDE4C3] text-[#438437] px-3 py-2 rounded"
				onClick={openModal}
			>
				Change Password
			</button>
			<Modal
				// className="border-1"
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				style={customStyles}
				contentLabel="Example Modal"
			>
				<div className="py-2"></div>
				<form onSubmit={changePassword}>
					<div className="p-3">
						<h3 className="text-lg font-semibold">Change Password</h3>
						<div className="relative my-3">
							<label className="block text-sm font-medium text-zinc-700 dark:text-zinc-300 mb-2">
								Current Password <span className="text-red-500">*</span>
							</label>
							<div className="relative">
								<input
									type={showPassword ? "text" : "password"}
									id="oldpassword"
									autoComplete="password"
									pattern="(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}"
									className="w-full border rounded-lg py-2 px-3 text-zinc-700 dark:text-zinc-300 bg-transparent  pr-10"
									placeholder="Password"
									required
									name="currentPassword"
									onChange={handleChangePassword}
								/>
								<button
									type="button"
									onClick={() => setShowPassword(!showPassword)}
									className="absolute inset-y-0 right-3 flex items-center text-zinc-500 hover:text-zinc-700 dark:hover:text-zinc-400"
								>
									{showPassword ? (
										<AiOutlineEyeInvisible size={20} />
									) : (
										<AiOutlineEye size={20} />
									)}
								</button>
							</div>
						</div>
						<div className="relative">
							<label className="block text-sm font-medium text-zinc-700 dark:text-zinc-300 mb-2">
								New Password{" "}
								<Tooltip position="right">
									<ul className=" list-disc pl-4">
										<li>At least 6 characters long</li>
										<li>At least one uppercase letter</li>
										<li>At least one number</li>
										<li>At least one special character (@$!%*?&)</li>
									</ul>
								</Tooltip>
							</label>
							<div className="relative ">
								<input
									type={showNewPassword ? "text" : "password"}
									id="newpassword"
									autoComplete="password"
									pattern="(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}"
									onInvalid={(e) =>
										(e.target as HTMLInputElement).setCustomValidity(
											"Password does not meet the required criteria. Please ensure it meets all the specified requirements."
										)
									}
									onInput={(e) =>
										(e.target as HTMLInputElement).setCustomValidity("")
									}
									className="w-full border border-gray-300 rounded-lg py-2 px-3 text-zinc-700 bg-transparent focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
									placeholder="Password"
									name="newPassword"
									required
									onChange={handleChangePassword}
								/>
								<button
									type="button"
									onClick={() => setNewShowPassword(!showNewPassword)}
									className="absolute inset-y-0 right-3 flex items-center text-zinc-500 hover:text-zinc-700 dark:hover:text-zinc-400"
								>
									{showNewPassword ? (
										<AiOutlineEyeInvisible size={20} />
									) : (
										<AiOutlineEye size={20} />
									)}
								</button>
							</div>
						</div>

						<div className="my-3">
							<label className="block text-sm font-medium text-zinc-700 dark:text-zinc-300 mb-2">
								Confirm Password <span className="text-red-500">*</span>
							</label>
							<input
								onChange={handleChangePassword}
								name="confirmPassword"
								type="password"
								autoComplete="new-password"
								required
								placeholder="Confirm Password"
								className="w-full border rounded-lg py-2 px-3 text-zinc-700 dark:text-zinc-300 bg-transparent "
							/>
						</div>
						<div className="mt-6 flex justify-end space-x-3">
							<button className="bg-[#BDE4C3] text-[#438437] px-4 py-2 rounded hover:scale-110 transition">
								Update
							</button>
							<button
								onClick={closeModal}
								className="px-4 py-2 text-[#438437] border-1 rounded-md hover:scale-110 transition"
							>
								Cancel
							</button>
						</div>
					</div>
				</form>
			</Modal>
		</div>
	);
};

export default ChangePasswordModal;
